export default "__VITE_ASSET__BnZQz6EH__"